import { useEffect, useState } from "react";
import * as gigService from "../../src/services/gig-service"
import { GigPreview } from "./models/GigPreview";
import { Category } from "./models/Category";

export const useGetMyGigs = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [gigs, setGigs] = useState<Array<GigPreview>>([]);
    useEffect(() => {
        gigService.getMyGigs().then((data: Array<GigPreview>) => {
            setGigs(data);
            setIsLoading(false);
        });
    }, []);

    return {gigs, isLoading};
}

export const useGetGigsAvailableToinvite = (candidateId: string) => {
    const [isLoading, setIsLoading] = useState(true);
    const [gigs, setGigs] = useState<Array<GigPreview>>([]);
    useEffect(() => {
        gigService.getGigsAvailableToInvite(candidateId).then((data: Array<GigPreview>) => {
            setGigs(data);
            setIsLoading(false);
        });
    }, []);

    return {gigs, isLoading};
}

export const useGetJobCategories = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState<Array<Category>>([]);

    useEffect(() => {
        gigService.getJobCategories().then((data: Array<Category>) => {
            setCategories(data);
            setIsLoading(false);
        });
    }, []);

    return {categories, isLoading};
}

export const useGetGigTitles = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [gigTitles, setGigTitles] = useState<Array<string>>([]);

    useEffect(() => {
        gigService.getGigTitles().then((data: Array<string>) => {
            setGigTitles(data);
            setIsLoading(false);
        });
    }, []);

    return {gigTitles, isLoading};
}

export const useCreateGig = () => {
    const[isLoading, setIsLoading] = useState(false);

    const createGig = async (formData: FormData) => {
        setIsLoading(true);
        await gigService.createGig(formData);
        setIsLoading(false);
    }



    return {createGig, isLoading};

}

// export const usetGetGigDetails = (id: string) => {
//     const [isLoading, setIsLoading] = useState(true);
//     const [gig, setGig] = useState<GigPreview | undefined>(undefined);


//     useEffect(() => {
//         gigService.getGigDetails(id).then((data: GigPreview) => {
//             setGig(data);
//             setIsLoading(false);
//         });
//     }, []);

//     return {gig, isLoading};
// }
